module.exports = __webpack_public_path__ + "media/invite/download-a6a129aa.svg";